import { useEffect, useRef, useState } from 'preact/hooks'
import { on } from 'helpers/dom'

function ProductQuantity({ quantity, max, setQuantity, min = 1, disabled = false, changeQuantity = null }) {
  const [value, setValue] = useState(quantity)
  const [message, setMessage] = useState(null)
  const inputRef = useRef(null)

  const onChange = (count) => {
    const current = value + count
    if (current >= min && current <= max) {
      setValue(current)
      setQuantity(current)
      if (changeQuantity) {
        changeQuantity(current)
      }
    } else if (current > max) {
      changeMessage()
    }
  }

  const onValidate = (value) => /^\d+$/.test(value)

  const onChangeInput = (e) => {
    e.preventDefault()
    const currentQuantity = parseInt(e.target.value)
    const isValidated = onValidate(currentQuantity)

    if (isNaN(currentQuantity)) {
      inputRef.current.value = value
      return
    }

    setValue(currentQuantity)

    if (inputRef && inputRef.current) {
      inputRef.current.value = currentQuantity
    }

    if (!isValidated) {
      if (currentQuantity !== 0 && currentQuantity < min) {
        setMessage('Enter a positive numbers')
      } else {
        setMessage('Enter only number')
      }
      return
    }

    setQuantity(currentQuantity)

    if (currentQuantity <= max && currentQuantity >= 0) {
      setMessage(null)
    } else {
      changeMessage()
    }
  }

  const changeMessage = () => {
    if (max > 1) {
      setMessage(`We have ${max} items`)
    } else {
      setMessage('We have only 1 item')
    }
  }

  useEffect(() => {
    if (inputRef && inputRef.current) {
      on(
        'keydown',
        (event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            onChangeInput(event)
          }
        },
        inputRef.current
      )
    }
  }, [])

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.value = quantity
      setValue(quantity)
    }
  }, [quantity])

  return (
    <>
      <div className="relative flex items-center justify-between border border-default rounded overflow-hidden">
        <button
          type="button"
          name="minus"
          className="flex items-center justify-center p-2 w-10 md:w-12 h-10 md:h-12"
          disabled={value < min || disabled}
          onClick={() => onChange(-1)}
          aria-label="previous-page"
        >
          <svg viewBox="0 0 20 20" class="icon" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="icon-minus" d="M15.625 10H4.375" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <div>
          <input
            ref={inputRef}
            className="w-[18px] text-center border-none p-0 text-base"
            type="number"
            min={min}
            max={max}
            onChange={onChangeInput}
            onBlur={onChangeInput}
            value={value}
            aria-label="page-number"
          />
          <span>{value > 1 ? 'cartons' : 'carton'}</span>
        </div>
        <button
          type="button"
          name="plus"
          className="flex items-center justify-center p-2 w-10 h-10 md:w-12 md:h-12"
          disabled={value < min || disabled}
          onClick={() => onChange(1)}
          aria-label="next-page"
        >
          <svg viewBox="0 0 20 20" class="icon" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="icon-plus" d="M10 4.375v11.25M15.625 10H4.375" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      {message && <span className="text-xs text-error">{message}</span>}
    </>
  )
}

export default ProductQuantity
